import { render, staticRenderFns } from "./docNumberRule-add-or-update.vue?vue&type=template&id=c6839306&scoped=true"
import script from "./docNumberRule-add-or-update.vue?vue&type=script&lang=js"
export * from "./docNumberRule-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./docNumberRule-add-or-update.vue?vue&type=style&index=0&id=c6839306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6839306",
  null
  
)

export default component.exports